import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from '../../../hooks';
import { NAV_ITEM_BOOKMARKS_GROUP_ID } from '../../../constants/Bookmarks';
const getNavItemsById = state => state.navItems.byId;
const getBookmarksCount = createSelector([getNavItemsById], navItemsById => {
  var _navItemsById$NAV_ITE;
  return ((_navItemsById$NAV_ITE = navItemsById[NAV_ITEM_BOOKMARKS_GROUP_ID].children) === null || _navItemsById$NAV_ITE === void 0 ? void 0 : _navItemsById$NAV_ITE.length) || 0;
});
const useBookmarksCount = () => {
  const bookmarksCount = useAppSelector(getBookmarksCount);
  return bookmarksCount;
};
export default useBookmarksCount;